var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_vm.statusSucceed
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Name" } }, [_vm._v("Name:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Name of organization" },
                domProps: { value: _vm.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.name = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Name", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Description" } }, [
                _vm._v("Description:"),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.description,
                    expression: "description",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: "Description of organization" },
                domProps: { value: _vm.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.description = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Description", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInitial || _vm.statusInvalid,
                  expression: "statusInitial || statusInvalid",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button" },
              on: { click: _vm.handleCreateOrganizationUnitCommandV1 },
            },
            [_vm._v("Create")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInvoking,
                  expression: "statusInvoking",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button", disabled: "" },
            },
            [_vm._v("Creating...")]
          ),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("h1", [_vm._v("Congratulation!")]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "Organization was created. Now you can switch to this organization."
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-lg",
              attrs: { href: "/#/admin/organizations/manage", role: "button" },
            },
            [_vm._v("Manage organizations")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
                "margin-top": "20px",
              },
            },
            [_vm._v("Create an organziation")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }